import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { map } from 'lodash';
import { Filters } from '@components/price-calendar/filters/Filters';
import { Filters as FiltersState, PriceCalendarFiltersState } from '@model/state/price-calendar-state';
import { BOARD_BASES, DURATIONS, FILTER_DEFAULTS } from '@model/price-calendar';
import { getPriceCalendarFilters } from '@state/slices/price-calendar/filter/priceCalendarFilterSelectors';
import { setFilters } from '@state/slices/price-calendar/filter/priceCalendarFilterSlice';
import { getDealFinderState } from '@state/slices/deal-finder/dealFinderSelectors';
import { getAlgoliaStateAirports } from '@state/slices/algolia/algoliaSelectors';
import { SearchType } from '@model/iceberg/deal-finder/deal-finder';
import { DealFinderState } from '@model/state';
import { getBasketFlight, getBasketMealPlan } from '@state/basket/basketSelectors';
import { Flight } from '@model/iceberg/booking/package';
import { BoardBasisSearch } from '@model/common';
import { dispatch } from '@state/store';

interface FiltersContainerProps {
  loading: boolean;
  viewWithFlightsSearch?: () => void;
  onChange: (filters: PriceCalendarFiltersState) => void;
}

export const FiltersContainer = ({ loading, viewWithFlightsSearch, onChange }: FiltersContainerProps) => {
  const [filtersChanged, setFiltersChanged] = useState(false);

  const filtersState: PriceCalendarFiltersState = useSelector(getPriceCalendarFilters);
  const dealFinderState: DealFinderState = useSelector(getDealFinderState);
  const basketMealPlan: string | undefined = useSelector(getBasketMealPlan);
  const basketFlight: Flight | null = useSelector(getBasketFlight);

  const handleOnChange = (payload: FiltersState) => {
    dispatch(setFilters(payload));
    setFiltersChanged(true);

    const updatedFilters = { ...filtersState, ...payload };
    onChange(updatedFilters);
  };

  const basketAirport = basketFlight?.outbound[0].departure.code;

  const {
    response: {
      data: { filters: { airports, boards, durations } = {} }
    },
    occupancy,
    airport,
    board,
    duration
  } = filtersState;
  const algoliaAirports = useSelector(getAlgoliaStateAirports);

  const displayAirport = filtersChanged ? airport : basketAirport || airport;
  const filterAirport =
    displayAirport ||
    (dealFinderState.searchType === SearchType.HOTEL_ONLY
      ? ''
      : dealFinderState.airports.length > 0
        ? dealFinderState.airports[0]
        : FILTER_DEFAULTS.airport);
  const filterBoard = board || BoardBasisSearch[basketMealPlan || ''] || FILTER_DEFAULTS.boardBasis;
  const filterDuration = duration || dealFinderState.duration || FILTER_DEFAULTS.duration;
  const filterOccupancy = !filtersChanged && dealFinderState.occupancy ? dealFinderState.occupancy : occupancy;

  return (
    <Filters
      airport={filterAirport}
      airports={airports && airports?.length > 0 ? airports : map(algoliaAirports, 'airport')}
      board={filterBoard}
      boards={boards && boards.length > 0 ? boards : BOARD_BASES}
      duration={filterDuration}
      durations={durations && durations.length > 0 ? durations : DURATIONS}
      occupancy={filterOccupancy}
      onChange={handleOnChange}
      loading={loading}
      viewWithFlightsSearch={viewWithFlightsSearch}
    />
  );
};
